var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Left",
    transform: "translate(-2.000000, 0.000000)",
    fill: "#959393"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.65,7.75 C11.775,6.975 12.5,5.7 12.5,4.25 C12.5,1.9 10.6,0 8.25,0 C5.9,0 4,1.9 4,4.25 C4,5.7 4.725,6.975 5.85,7.75 C3.625,8.45 2,10.55 2,13 L2,16 L14.5,16 L14.5,13 C14.5,10.55 12.875,8.45 10.65,7.75 Z M5,4.25 C5,2.45 6.45,1 8.25,1 C10.05,1 11.5,2.45 11.5,4.25 C11.5,6.05 10.05,7.5 8.25,7.5 C6.45,7.5 5,6.05 5,4.25 Z M13.5,15 L3,15 L3,13 C3,10.525 5.025,8.5 7.5,8.5 L9,8.5 C11.475,8.5 13.5,10.525 13.5,13 L13.5,15 Z",
    id: "Icon-Color"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.df600004.svg";
export { ForwardRef as ReactComponent };